import { render, staticRenderFns } from "./PageSelectDialog.vue?vue&type=template&id=767e564a"
import script from "./PageSelectDialog.vue?vue&type=script&lang=js"
export * from "./PageSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./PageSelectDialog.vue?vue&type=style&index=0&id=767e564a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports